import { QesIcons } from "../../../../shared/icons/qesIcons";
import { QesIcon } from "../../../../shared/icons/QESIcon";

import "mapbox-gl/dist/mapbox-gl.css";
import { MARKET_PROVIDER_COLOR, MEMBERS_WITH_ACCESS_COLOR, MEMBERS_WITHOUT_ACCESS_COLOR, NETWORK_PROVIDER_COLOR, PROSPECT_PROVIDER_COLOR, TARGET_PROVIDER_COLOR } from "../NetworkCoverageMapsColors";
import { MapCustomControlProps } from "@app/shared/mapping/MapCustomControlProps";

import { createPortal } from "react-dom";
import { useMapboxControl } from "@app/shared/mapping/useMapBoxControl";

interface LegendItem {
  color: string;
  icon: string;
  label: string;
}

const LegendSection: React.FC<{ title: string; items: LegendItem[] }> = ({ title, items }) => (
  <div>
    <span className="provider-member-layer-control__title">{title}</span>
    <div className="provider-member-layer-control__layers-container">
      {items.map((item, index) => (
        <div key={index} className="provider-member-layer-control__item">
          <QesIcon
            iconName={item.icon}
            svgStyle={{ fill: item.color, marginRight: "8px" }}
            description={item.label}
          />
          <span className="provider-member-layer-control__value">{item.label}</span>
        </div>
      ))}
    </div>
  </div>
);

const NetworkCoverageMapLegendControl: React.FC<MapCustomControlProps> = ({ignoreInMapExport, mapRef, position}) => {

  const legendData = [
    {
      items: [
        { color: MEMBERS_WITH_ACCESS_COLOR , icon: QesIcons.Untitled.Circle, label: "With Access" },
        { color: MEMBERS_WITHOUT_ACCESS_COLOR , icon: QesIcons.Untitled.Circle, label: "Without Access" },
      ],
      title: "Members",
    },
    {
      items: [
        { color: NETWORK_PROVIDER_COLOR, icon: QesIcons.Untitled.Square, label: "Network Provider" },
        { color: TARGET_PROVIDER_COLOR, icon: QesIcons.FontAwesome.Star, label: "Targeted Provider" },
        { color: PROSPECT_PROVIDER_COLOR, icon: QesIcons.Untitled.Pentagon, label: "Prospect Provider" },
        { color: MARKET_PROVIDER_COLOR, icon: QesIcons.Untitled.HexagonOnVertex, label: "Market Provider" },
      ],
      title: "Providers",
    },
  ] as { title: string; items: LegendItem[] }[];

  const container = useMapboxControl({mapRef, position});
  if (!container) return null;

  return createPortal (
    <div className="legend-control-container" {...(ignoreInMapExport ? { 'data-html2canvas-ignore': '' } : {})}>
      {legendData.map((section, index) => (
        <LegendSection key={index} title={section.title} items={section.items} />
      ))}
    </div>, 
    container
  )

};

export default NetworkCoverageMapLegendControl;
